import { render, staticRenderFns } from "./NvBookCover.vue?vue&type=template&id=8e9e4112&scoped=true&"
import script from "./NvBookCover.vue?vue&type=script&lang=js&"
export * from "./NvBookCover.vue?vue&type=script&lang=js&"
import style0 from "./NvBookCover.vue?vue&type=style&index=0&id=8e9e4112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9e4112",
  null
  
)

export default component.exports